import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft, Info } from "lucide-react";
import api from "@/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-md shadow-lg p-8" data-testid="forgot-password">
        <Link to="/login" className="text-xs text-blue-700 hover:underline inline-flex items-center gap-1 mb-4">
          <ArrowLeft className="w-3 h-3" /> Torna al login
        </Link>

        {!sent && (
          <>
            <div className="overline text-blue-700 mb-2">Recupero password</div>
            <h1 className="font-display text-2xl font-black mb-2">Hai dimenticato la password?</h1>
            <p className="text-sm text-slate-600 mb-6">
              Inserisci la tua email. Se è registrata, riceverai un link per reimpostare la password.
            </p>

            <form onSubmit={submit} className="space-y-3">
              <div>
                <label className="text-xs font-semibold text-slate-600 block mb-1">Email</label>
                <div className="relative">
                  <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email"
                    placeholder="nome@dominio.it"
                    className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-sm text-sm"
                    required
                    autoComplete="email"
                  />
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="btn-forgot"
                className="w-full py-3 bg-blue-700 hover:bg-blue-800 text-white font-semibold rounded-sm disabled:opacity-60"
              >
                {loading ? "Invio in corso..." : "Invia link di recupero"}
              </button>
            </form>
          </>
        )}

        {sent && (
          <div className="text-center">
            <div className="text-5xl mb-4">✉️</div>
            <h1 className="font-display text-2xl font-black mb-2">Richiesta ricevuta</h1>
            <p className="text-sm text-slate-600 mb-6">
              Se l'email <b>{email}</b> è registrata, riceverai a breve un link per reimpostare la password.
            </p>
            <div className="p-3 border border-amber-300 bg-amber-50 rounded-sm text-xs text-amber-900 text-left flex gap-2">
              <Info className="w-4 h-4 shrink-0 mt-0.5" />
              <div>
                Non ricevi l'email? Contatta il tuo amministratore: può recuperare
                il link di reset dal pannello <b>Utenti & Ruoli</b> e passartelo direttamente.
              </div>
            </div>
            <Link to="/login" className="mt-6 inline-block text-blue-700 hover:underline text-sm font-semibold">
              Torna al login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
